import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer25 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            setEmail('');
        }
    };

    const shopLinks = [
        { label: 'Kurtas', path: '/template25/shop' },
        { label: 'Sherwanis', path: '/template25/shop' },
        { label: 'Lehengas', path: '/template25/shop' },
        { label: 'Sarees', path: '/template25/shop' },
        { label: 'Indo-Western', path: '/template25/shop' },
        { label: 'Accessories', path: '/template25/shop' },
    ];

    const customerCareLinks = [
        { label: 'Contact Us', path: '/template25/contact' },
        { label: 'Shipping Policy', path: '/template25/shipping-policy' },
        { label: 'Returns & Exchange', path: '/template25/shipping-exchange' },
        { label: 'FAQs', path: '/template25/faqs' },
        { label: 'Track Order', path: '/template25/orders' },
    ];

    const companyLinks = [
        { label: 'About Us', path: '/template25/about' },
        { label: 'Our Story', path: '/template25/about' },
        { label: 'Privacy Policy', path: '/template25/privacy-policy' },
        { label: 'Terms & Conditions', path: '/template25/terms' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap');
            `}</style>

            <footer style={{ backgroundColor: '#111111', borderTop: '2px solid #0D7C66' }}>
                {/* Main Footer Content */}
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '64px 24px',
                    }}
                    className="sahaj-footer-main"
                >
                    <div className="sahaj-footer-grid">
                        {/* Column 1: Brand & Contact */}
                        <div>
                            <h3
                                style={{
                                    fontFamily: "'Space Grotesk', sans-serif",
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#FFFFFF',
                                    letterSpacing: '3px',
                                    margin: '0 0 12px 0',
                                    textTransform: 'uppercase',
                                }}
                            >
                                SAHAJ
                            </h3>
                            <p
                                style={{
                                    fontFamily: "'IBM Plex Sans', -apple-system, sans-serif",
                                    fontSize: '14px',
                                    color: '#6C757D',
                                    lineHeight: 1.7,
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Contemporary Indian fashion. Clean lines, honest fabrics, rooted in craft.
                            </p>

                            {/* WhatsApp prominent */}
                            <a
                                href="https://wa.me/919876543210"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    padding: '10px 20px',
                                    backgroundColor: 'transparent',
                                    border: '1px solid #0D7C66',
                                    color: '#0D7C66',
                                    fontFamily: "'IBM Plex Sans', sans-serif",
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    letterSpacing: '0.5px',
                                    textDecoration: 'none',
                                    textTransform: 'uppercase',
                                    borderRadius: 0,
                                    transition: 'all 0.3s ease',
                                    marginBottom: '20px',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#0D7C66';
                                    e.currentTarget.style.color = '#FFFFFF';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent';
                                    e.currentTarget.style.color = '#0D7C66';
                                }}
                            >
                                {/* WhatsApp icon */}
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                                </svg>
                                WhatsApp Us
                            </a>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                                <Phone size={14} style={{ color: '#0D7C66', flexShrink: 0 }} />
                                <span
                                    style={{
                                        fontFamily: "'IBM Plex Sans', sans-serif",
                                        fontSize: '14px',
                                        color: '#FFFFFF',
                                    }}
                                >
                                    +91 98765 43210
                                </span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Mail size={14} style={{ color: '#0D7C66', flexShrink: 0 }} />
                                <span
                                    style={{
                                        fontFamily: "'IBM Plex Sans', sans-serif",
                                        fontSize: '14px',
                                        color: '#FFFFFF',
                                    }}
                                >
                                    hello@sahaj.in
                                </span>
                            </div>
                        </div>

                        {/* Column 2: Shop */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Space Grotesk', sans-serif",
                                    fontSize: '13px',
                                    fontWeight: 700,
                                    color: '#FFFFFF',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Shop
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {shopLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'IBM Plex Sans', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                color: '#6C757D',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#0D7C66')}
                                            onMouseLeave={(e) => (e.target.style.color = '#6C757D')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 3: Customer Care */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Space Grotesk', sans-serif",
                                    fontSize: '13px',
                                    fontWeight: 700,
                                    color: '#FFFFFF',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Help
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {customerCareLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'IBM Plex Sans', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                color: '#6C757D',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#0D7C66')}
                                            onMouseLeave={(e) => (e.target.style.color = '#6C757D')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 4: Company + Social */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Space Grotesk', sans-serif",
                                    fontSize: '13px',
                                    fontWeight: 700,
                                    color: '#FFFFFF',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Company
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {companyLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'IBM Plex Sans', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                color: '#6C757D',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#0D7C66')}
                                            onMouseLeave={(e) => (e.target.style.color = '#6C757D')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>

                            {/* Social Icons */}
                            <div style={{ display: 'flex', gap: '10px', marginTop: '24px' }}>
                                {[Instagram, Facebook].map((Icon, i) => (
                                    <a
                                        key={i}
                                        href="#"
                                        style={{
                                            width: '38px',
                                            height: '38px',
                                            border: '1px solid #2A2A2A',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#6C757D',
                                            transition: 'all 0.3s ease',
                                            textDecoration: 'none',
                                            borderRadius: 0,
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#0D7C66';
                                            e.currentTarget.style.color = '#0D7C66';
                                            e.currentTarget.style.backgroundColor = 'rgba(13, 124, 102, 0.1)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = '#2A2A2A';
                                            e.currentTarget.style.color = '#6C757D';
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }}
                                    >
                                        <Icon size={16} />
                                    </a>
                                ))}
                                {/* Pinterest */}
                                <a
                                    href="#"
                                    style={{
                                        width: '38px',
                                        height: '38px',
                                        border: '1px solid #2A2A2A',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#6C757D',
                                        transition: 'all 0.3s ease',
                                        textDecoration: 'none',
                                        borderRadius: 0,
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.borderColor = '#0D7C66';
                                        e.currentTarget.style.color = '#0D7C66';
                                        e.currentTarget.style.backgroundColor = 'rgba(13, 124, 102, 0.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.borderColor = '#2A2A2A';
                                        e.currentTarget.style.color = '#6C757D';
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M8 12a4 4 0 1 1 8 0c0 2.5-1.5 4.5-3 6l-1 3" />
                                        <path d="M12 2a10 10 0 1 0 4 19.2" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Made in India + Bottom Bar */}
                <div style={{ borderTop: '1px solid #2A2A2A' }}>
                    <div
                        style={{
                            maxWidth: '1400px',
                            margin: '0 auto',
                            padding: '20px 24px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: '16px',
                            }}
                            className="sahaj-footer-bottom"
                        >
                            <p
                                style={{
                                    fontFamily: "'IBM Plex Sans', -apple-system, sans-serif",
                                    fontSize: '12px',
                                    color: '#6C757D',
                                    margin: 0,
                                }}
                            >
                                &copy; 2026 SAHAJ. All rights reserved.
                            </p>

                            {/* Made in India Badge */}
                            <div
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '6px 14px',
                                    border: '1px solid #2A2A2A',
                                    borderRadius: 0,
                                }}
                            >
                                <MapPin size={12} style={{ color: '#0D7C66' }} />
                                <span
                                    style={{
                                        fontFamily: "'IBM Plex Sans', sans-serif",
                                        fontSize: '11px',
                                        fontWeight: 600,
                                        color: '#FFFFFF',
                                        letterSpacing: '1px',
                                        textTransform: 'uppercase',
                                    }}
                                >
                                    Made in India
                                </span>
                            </div>

                            {/* Payment Icons */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" fill="#1A1A1A" stroke="#2A2A2A" />
                                    <text x="18" y="14" textAnchor="middle" fill="#6C757D" fontSize="8" fontWeight="bold" fontFamily="IBM Plex Sans, sans-serif">VISA</text>
                                </svg>
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" fill="#1A1A1A" stroke="#2A2A2A" />
                                    <circle cx="15" cy="12" r="5" fill="#6C757D" opacity="0.5" />
                                    <circle cx="21" cy="12" r="5" fill="#6C757D" opacity="0.5" />
                                </svg>
                                <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                    <rect width="36" height="24" fill="#1A1A1A" stroke="#2A2A2A" />
                                    <text x="18" y="14" textAnchor="middle" fill="#6C757D" fontSize="7" fontWeight="bold" fontFamily="IBM Plex Sans, sans-serif">UPI</text>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Responsive Styles */}
                <style>{`
                    .sahaj-footer-grid {
                        display: grid;
                        grid-template-columns: 1.5fr 1fr 1fr 1fr;
                        gap: 48px;
                    }
                    @media (max-width: 768px) {
                        .sahaj-footer-grid {
                            grid-template-columns: 1fr;
                            gap: 36px;
                        }
                        .sahaj-footer-main {
                            padding: 40px 24px !important;
                        }
                        .sahaj-footer-bottom {
                            flex-direction: column;
                            align-items: center !important;
                            text-align: center;
                        }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                        .sahaj-footer-grid {
                            grid-template-columns: repeat(2, 1fr);
                        }
                    }
                `}</style>
            </footer>
        </>
    );
};

export default Footer25;
